var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1653 7.44798C31.5881 7.23205 30.6835 7 29.5533 7C26.6736 7 24.6443 8.44574 24.6273 10.5164C24.6116 12.0486 26.0755 12.9017 27.1814 13.4125C28.3154 13.9339 28.6973 14.2673 28.6913 14.7335C28.6841 15.4479 27.7859 15.7741 26.9481 15.7741C25.7813 15.7741 25.162 15.6133 24.2046 15.2154L23.8287 15.0457L23.4196 17.4315C24.1012 17.7285 25.3591 17.9868 26.6663 18C29.7304 18 31.7196 16.5712 31.7418 14.3594C31.7524 13.1469 30.9764 12.2243 29.2954 11.4645C28.2759 10.9711 27.6522 10.6415 27.659 10.1426C27.659 9.70058 28.1865 9.22588 29.3273 9.22588C30.2817 9.21103 30.9713 9.41847 31.5089 9.63482L31.7707 9.757L32.1653 7.44798ZM18.6814 17.8418L20.5038 7.18583H23.418L21.5948 17.8418H18.6814ZM37.3878 7.19625H39.6401L41.9988 17.8446H39.294C39.294 17.8446 39.0271 16.6211 38.9399 16.2482C38.7144 16.2482 37.773 16.247 36.8882 16.2459L36.8758 16.2459C36.0961 16.2449 35.3632 16.244 35.207 16.244C35.0938 16.532 34.5936 17.8446 34.5936 17.8446H31.5325L35.8609 8.0799C36.1682 7.38546 36.6897 7.19625 37.3878 7.19625ZM36.0452 14.0644C36.2866 13.4505 37.2069 11.0851 37.2069 11.0851C37.1984 11.099 37.2551 10.9523 37.3325 10.752L37.3325 10.7519C37.4137 10.5418 37.5176 10.2728 37.593 10.0682L37.7897 10.9871C37.7897 10.9871 38.3482 13.5303 38.4652 14.0644H36.0452ZM13.3837 14.46L16.2366 7.19358H19.3237L14.7357 17.8288L11.6516 17.833L9.04297 8.51291C10.893 9.43601 12.5485 11.2805 13.0793 12.9833L13.3837 14.46Z",
    fill: "#1A1F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7374 7.18652H6.03703L6 7.40797C9.65663 8.29077 12.0762 10.422 13.0804 12.9835L12.0583 8.08587C11.8821 7.41094 11.37 7.20986 10.7374 7.18652Z",
    fill: "#F9A51A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLight);
export default __webpack_public_path__ + "static/media/visa-light.c5536252700a114ed602261bb1d7b956.svg";
export { ForwardRef as ReactComponent };